module.exports = __webpack_public_path__ + "img/cyy.f49e2f18.png";